import React from 'react';
import { MapContext } from './MapContext';
const useMap = () => React.useContext(MapContext);
export default useMap;
